import UmamiAnalytics from "@danielgtmn/umami-react";
import { usePage } from "@inertiajs/react";
import { ReactNode } from "react";
import { Info } from "lucide-react";

import { SharedProps } from "@/types";
import { Callout } from "@/ui";

import styles from "./Layout.module.css";
import LayoutFooter from "./LayoutFooter";
import NavigationBar from "./NavigationBar";

type LayoutProps = {
  children: ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  const { flash } = usePage<SharedProps>().props;

  const hasFlash = typeof flash !== "undefined" && Object.keys(flash).length > 0;

  return (
    <>
      <main id="app-main" className={styles.main}>
        <NavigationBar />

        <div>
          {hasFlash && (
            <div className={styles.flash}>
              {flash?.alert && (
                <Callout variant="alert" icon={<Info />}>
                  {flash.alert}
                </Callout>
              )}

              {flash?.notice && (
                <Callout variant="notice" icon={<Info />}>
                  {flash.notice}
                </Callout>
              )}
            </div>
          )}

          <div className={styles.children}>{children}</div>
        </div>

        <LayoutFooter />
      </main>

      <UmamiAnalytics
        url="https://u.albion.build"
        websiteId="23bc9568-59d7-49c4-a97b-bf6023c19532"
      />
    </>
  );
}
